import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";

// Extracts a voucher code from a scanned URL or raw text
function extractCode(text) {
  try {
    const m = text.match(/(?:voucher|ticket|pass)\/([A-Z0-9]{10})/i);
    if (m) return m[1].toUpperCase();
  } catch (e) {}
  const raw = text.trim().toUpperCase();
  if (/^[A-Z0-9]{10}$/.test(raw)) return raw;
  return null;
}

export default function QRScanner({ onResult, onClose }) {
  const ref = useRef(null);
  const scannerRef = useRef(null);

  useEffect(() => {
    const id = "gp-qr-reader";
    const scanner = new Html5Qrcode(id);
    scannerRef.current = scanner;
    let active = true;
    scanner
      .start(
        { facingMode: "environment" },
        { fps: 10, qrbox: { width: 230, height: 230 } },
        (decodedText) => {
          const code = extractCode(decodedText);
          if (code && active) {
            active = false;
            scanner.stop().then(() => onResult(code)).catch(() => onResult(code));
          }
        },
        () => {}
      )
      .catch((err) => {
        console.error("QR start error", err);
      });
    return () => {
      try {
        if (scannerRef.current && scannerRef.current.isScanning) {
          scannerRef.current.stop().catch(() => {});
        }
      } catch (e) {}
    };
  }, [onResult]);

  return (
    <div className="fixed inset-0 z-[80] bg-black/80 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-5 w-full max-w-[380px]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="font-semibold text-[#16243b]">Scan ticket QR</h3>
          <button onClick={onClose} className="text-[#5a6b80] hover:text-[#16243b]">Close</button>
        </div>
        <div id="gp-qr-reader" ref={ref} className="rounded-xl overflow-hidden" />
        <p className="text-xs text-[#8a97a8] mt-3 text-center">Point your camera at the ticket QR code.</p>
      </div>
    </div>
  );
}
